document.addEventListener("DOMContentLoaded", function () {
  const footerToggles = document.querySelectorAll(".footer-section-toggle");

  footerToggles.forEach((toggle) => {
    toggle.addEventListener("click", function () {
      const content = this.nextElementSibling;
      const icon = this.querySelector(".toggle-icon");

      footerToggles.forEach((otherToggle) => {
        if (otherToggle !== toggle) {
          const otherContent = otherToggle.nextElementSibling;
          const otherIcon = otherToggle.querySelector(".toggle-icon");

          if (!otherContent.classList.contains("hidden")) {
            otherContent.style.maxHeight = otherContent.scrollHeight + "px";
            otherContent.offsetHeight;
            otherContent.style.maxHeight = "0px";
            otherIcon.classList.remove("rotate-180");

            setTimeout(() => {
              otherContent.classList.add("hidden");
              otherContent.style.maxHeight = null;
            }, 200);
          }
        }
      });

      if (content.classList.contains("hidden")) {
        content.classList.remove("hidden");
        content.style.maxHeight = "0px";
        content.offsetHeight;
        requestAnimationFrame(() => {
          content.style.maxHeight = content.scrollHeight + "px";
          icon.classList.add("rotate-180");
        });
      } else {
        content.style.maxHeight = "0px";
        icon.classList.remove("rotate-180");

        setTimeout(() => {
          content.classList.add("hidden");
          content.style.maxHeight = null;
        }, 200);
      }
    });
  });

  function highlightCurrentPageSection() {
    const currentPageLinks = document.querySelectorAll("a.current-page");

    currentPageLinks.forEach((link) => {
      const dropdownContent = link.closest(".hidden");
      if (dropdownContent) {
        const toggle = dropdownContent.previousElementSibling;
        if (toggle && toggle.classList.contains("footer-section-toggle")) {
          toggle.click();
        }
      }
    });
  }

  highlightCurrentPageSection();

  const backToTopButton = document.getElementById("back-to-top");
  
  if (backToTopButton) {
    window.addEventListener("scroll", function() {
      if (window.pageYOffset > 300) {
        backToTopButton.classList.remove("translate-y-20", "opacity-0");
        backToTopButton.classList.add("translate-y-0", "opacity-100");
      } else {
        backToTopButton.classList.add("translate-y-20", "opacity-0");
        backToTopButton.classList.remove("translate-y-0", "opacity-100");
      }
    });
    
    backToTopButton.addEventListener("click", function() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
      
      function scrollToTop() {
        const c = document.documentElement.scrollTop || document.body.scrollTop;
        if (c > 0) {
          window.requestAnimationFrame(scrollToTop);
          window.scrollTo(0, c - c / 8);
        }
      }
      
      if (typeof window.scrollTo !== 'function') {
        scrollToTop();
      }
    });
    
    backToTopButton.addEventListener("mouseenter", function() {
      this.classList.add("animate-bounce");
      setTimeout(() => {
        this.classList.remove("animate-bounce");
      }, 500);
    });
  }
});
